module.exports = __webpack_public_path__ + "img/bonhommeRouge.6b1ad505.png";